import http from "~/config/httpRequest/http";

const saveGroup = (req) => {
	return new Promise((resolve, reject) => {
		http
			.post(`/GrupoMotorista/Salvar`, req)
			.then((res) => resolve(res.data))
			.catch((error) => reject(error));
	});
};

const getGroupsDrivers = () => {
	return new Promise((resolve, reject) => {
		http
			.get(`/GrupoMotorista/Buscar`)
			.then((res) => resolve(res))
			.catch((error) => reject(error));
	});
};

const deleteGroupsDrivers = (groupId) => {
	return new Promise((resolve, reject) => {
		http
			.delete(`/GrupoMotorista/Remover/?grupoId=${groupId}`)
			.then((res) => resolve(res))
			.catch((error) => reject(error));
	});
};

const getDriversLinkedGroupById = (groupId, pagination = {}) => {
	return new Promise((resolve, reject) => {
		const req = {
			Vinculado: true,
			GrupoId: groupId,
			FiltroGrid: {
				Length: pagination.length || 10,
				Index: pagination.page || 0,
				Search: pagination.search || "",
				SearchColumns: [
					{
						Name: "Nome",
						Data: "Nome",
						OrderTable: true,
						OrderDirection: "asc"
					}
				]
			},
		};

		http
			.post(`/GrupoMotorista/PesquisarVinculoMotoristasGrupo`, req)
			.then((res) => resolve(res))
			.catch((error) => reject(error));
	});
};

const getAvailableDriversForGroupById = (groupId, pagination = {}) => {
	return new Promise((resolve, reject) => {
		const req = {
			Vinculado: false,
			GrupoId: groupId,
			FiltroGrid: {
				Length: pagination.length || 10,
				Index: pagination.page || 0,
				Search: pagination.search || "",
				SearchColumns: [
					{
						Name: "Nome",
						Data: "Nome",
						OrderTable: true,
						OrderDirection: "asc"
					}
				]
			},
		};
		http
			.post(`/GrupoMotorista/PesquisarVinculoMotoristasGrupo`, req)
			.then((res) => resolve(res))
			.catch((error) => reject(error));
	});
};

const saveLinkDriver = (groupId, driversSelected = []) => {
	return new Promise((resolve, reject) => {
		const body = {
			vinculado: false,
			grupoId: groupId,
			motoristasSelecionados: driversSelected,
		};
		http
			.post(`/GrupoMotorista/SalvarVinculoMotoristasGrupo`, body)
			.then((res) => resolve(res.data))
			.catch((error) => reject(error));
	});
};

const saveUnbindDriver = (groupId, driversSelected = []) => {
	return new Promise((resolve, reject) => {
		const body = {
			vinculado: true,
			grupoId: groupId,
			motoristasSelecionados: driversSelected,
		};
		http
			.post(`/GrupoMotorista/SalvarVinculoMotoristasGrupo`, body)
			.then((res) => resolve(res.data))
			.catch((error) => reject(error));
	});
};

export default {
	saveGroup,
	getGroupsDrivers,
	getDriversLinkedGroupById,
	getAvailableDriversForGroupById,
	saveLinkDriver,
	saveUnbindDriver,
	deleteGroupsDrivers,
};
